import { NEW_MAP_DATA, MARKERS } from "../../store/MapConstants.js";

export interface buildingApiType {
  address: string;
  idBuilding: number;
  latitude: number;
  levels: any;
  longitude: number;
  name: string;
}

const baseURL = "";

// Function to find building by name/id in local data
export const findLocalGeoJsonBuilding = (
  query: string
): [number, number] | null => {
  const normalizedQuery = query.toLowerCase().trim();

  // Search in NEW_MAP_DATA (buildings)
  const building = NEW_MAP_DATA.find(
    (b: any) =>
      b.name?.toLowerCase() === normalizedQuery ||
      b.id?.toLowerCase() === normalizedQuery
  );

  if (building?.center) {
    // center is [lat, lng], but Mapbox needs [lng, lat]
    return [building.center[1], building.center[0]];
  }

  // Search in MARKERS
  const marker = MARKERS.find(
    (m: any) =>
      m.name?.toLowerCase() === normalizedQuery ||
      m.id?.toLowerCase() === normalizedQuery
  );

  if (marker?.coordinates) {
    // coordinates is [lat, lng], but Mapbox needs [lng, lat]
    return [marker.coordinates[1], marker.coordinates[0]];
  }

  return null;
};

export const useBuilding = () => {
  const getBuildingById = async (
    id: string | undefined
  ): Promise<buildingApiType> => {
    const request = await fetch(`${baseURL}/api/building/${id}`);
    const response = await request.json();
    return response;
  };

  return getBuildingById;
};
